import {format, toDate, utcToZonedTime, zonedTimeToUtc} from "date-fns-tz";

const timezone = "America/Los_Angeles";
const mtv = "America/Los_Angeles";


export const viewDate = (dt, fmt) => {
    return format(utcToZonedTime(dt, timezone), fmt, {timeZone: timezone});
}

export const utcDate = (dt) => {
    return zonedTimeToUtc(dt, timezone, {timeZone: timezone});
}

export const zonedDate = (dt) => {
    return utcToZonedTime(dt, timezone, {timeZone: timezone});
}

export const mtvDate = (dt) => {
    return utcToZonedTime(dt, mtv, {timeZone: timezone});
}

export const zonedStartOfDay = (dt) => {
    // Extract nominal date parts from the input Date object in the target timezone
    return toDate(format(dt, 'yyyy-MM-dd', { timeZone: mtv }) + 'T00:00:00', { timeZone: mtv });
}

export const adjustTime = (date, time, land = false) => {
    let zDate = utcToZonedTime(date, timezone);
    let zTime = utcToZonedTime(time, timezone);

    zTime.setFullYear(zDate.getFullYear());
    zTime.setMonth(zDate.getMonth());
    zTime.setDate(zDate.getDate());

    let offset = -1;
    let rollover = zTime > zDate;
    if (land) {
        offset = 1;
        rollover = zDate > zTime;
    }
    if (rollover) {
        zTime.setDate(zDate.getDate() + offset);
    }
    return zonedTimeToUtc(zTime, timezone).toISOString();
}

export const combineDateAndTime = (date, time) => {
    let zDate = utcToZonedTime(date, timezone);
    let zTime = utcToZonedTime(time, timezone);

    zTime.setFullYear(zDate.getFullYear());
    zTime.setMonth(zDate.getMonth());
    zTime.setDate(zDate.getDate());

    return zonedTimeToUtc(zTime, timezone).toISOString();
}
